import { Injectable } from '@angular/core';
import { AppInsights } from 'applicationinsights-js';
import { AppConfig } from "../model/config";
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

@Injectable()
export class AppInsightsService {
  private appInsights: ApplicationInsights;  

  constructor(private config: AppConfig) {
    this.appInsights = new ApplicationInsights({
      config: {
        connectionString: this.config.aiConnectionString,
        enableAutoRouteTracking: true // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }

  logPageView(name: string, url?: string, properties?: any, measurements?: any, duration?: number) {
    AppInsights.trackPageView(name, url, properties, measurements, duration);
  }
  logEvent(name: string, properties?: any, measurements?: any) {
    AppInsights.trackEvent(name, properties, measurements);
  }

  logException(exception: Error, properties?: any, measurements?: any) {
    AppInsights.trackException(exception, properties, measurements);
  }

  logTrace(message: string, properties?: any, measurements?: any) {
    AppInsights.trackTrace(message, properties, measurements);
  }

}
